import React, { useState, useEffect, useContext } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import { Button } from 'react-bootstrap'
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from 'react-bootstrap/AccordionContext';
// import screen600 from '../images/Screen600px.png'
import logo from '../images/huawei_logo.png'
import { Link } from "react-router-dom";

import { reqApkList } from './../service'
const Huawei = () => {
    const [apkList, setApkList] = useState([])
    const downloadMobileImg = {
        maxWidth: "100%"
    }

    const fixBotton = {
        position: "fixed",
        padding: "8px",
        backgroundColor: "#fff",
        bottom: 0,
        left: 0,
        right: 0,
    }

    const wrapperScreen = {
        maxWidth: "375px",
        margin: "auto"
    }

    const btnDownload = {
        border: "2px solid #63be55",
        fontSize: "14px",
        color: "#63be55"
    }

    const smallLogo = {
        height: "12px",
        marginLeft: "8px"
    }

    const requestsApk = async () => {
        // setIsError(true);
        reqApkList().then(res => {
            console.log(res)
            if (res.code === 200) {
                setApkList(res.result)
            }

        }).catch(err => {
            // setIsError(true);
        })
    }
    useEffect(() => {
        requestsApk()
    }, [])
    // console.log(apkList[apkList.length - 1])
    function ContextAwareToggle({ children, eventKey, callback }) {
        const currentEventKey = useContext(AccordionContext);
      
        const decoratedOnClick = useAccordionToggle(
          eventKey,
          () => callback && callback(eventKey),
        );
      
        const isCurrentEventKey = currentEventKey === eventKey;
      
        return (
          <Button
            type="button"
            variant="link"
            onClick={decoratedOnClick}
          >
            {isCurrentEventKey?"View Less":children}
          </Button>
        );
      }
    return (
        <div style={{
            "backgroundColor": "#63be55",
            height: "100vh",
            overflow: "hidden"
        }}>
            <figure className='downloadMobileApp'>
                <img style={downloadMobileImg} className='downloadMobileImg' src={apkList[0]?.image_url} alt={apkList[0]?.description} />
            </figure>
            <footer style={fixBotton}>
                <div style={wrapperScreen}>
                    <Accordion>


                        <div className="d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">APK version {apkList[0]?.version}</h5>
                            {/* <Button variant="link">more</Button> */}
                            <ContextAwareToggle eventKey="0">View More</ContextAwareToggle>
                            {/* <Accordion.Toggle as={Button}  variant="link" eventKey="0" className='pl-0 bg-transparent border-0'><ContextAwareToggle>View More</ContextAwareToggle></Accordion.Toggle> */}
                        </div>

                        <Accordion.Collapse eventKey="0">
                            <Card.Body className='px-0 py-1'>
                                <h6>Description</h6>
                                <p>{apkList[0]?.description}</p>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Accordion>
                    <div className="d-flex justify-content-between">
                        <span className="h6 font-weight-bold mb-0">
                            <span className="d-block">
                                Beverest Life
                            </span>
                            <span className="small d-block">
                                <span className="d-flex align-items-center">
                                    <span>Designed for</span>
                                    <span>
                                        <img style={smallLogo} src={logo} alt="" />
                                    </span>
                                </span>
                            </span>
                        </span>
                        <div className="dropdown">
                            <button className="btn dropdown-toggle" style={btnDownload} type="button" data-toggle="dropdown" aria-expanded="false">
                                Download
                            </button>
                            <div className="dropdown-menu">
                                {/* <Link to="/another-apk" className="dropdown-item">Latest version</Link> */}
                                <a className="dropdown-item" target='_blank' rel="noreferrer" href={apkList[0]?.file_url} >Latest version</a>
                                <Link to="/another-apk" className="dropdown-item">Previous version</Link>
                                {/* <a
                                    className="dropdown-item"
                                    href={process.env.REACT_APP_APK_URL + '/another-apk'}
                                // target="_blank" 
                                // rel={"noopener. noreferrer"}
                                >Another version</a> */}
                            </div>
                        </div>
                        {/* <a style={btnDownload} className="btn d-lg-inline-block mb-md-0 ml-md-3" href={process.env.REACT_APP_APK_URL}>Download</a> */}
                    </div>
                </div>
            </footer>

        </div>
    )
}


export default Huawei